import MapUtil from "../../../utils/MapUtil";
import * as ConfigStepEnum from "../../../configuration/config/ConfigStepMscore";
import * as Constants from "../../../Constants";
import DateUtils from "../../../utils/DateUtil";
import TimeZoneUtils from "../../../utils/TimeZoneUtils";
import VersionParser from "../../../utils/VersionParser";
import UAParser from "ua-parser-js";

/**
 * Specials parameters, must be transformed for mScore
 * @type {string}
 */
export const NB_SOCKETS = "nbsocket";

/**
 * Specials parameters, must be transformed for mScore
 * @type {string}
 */
export const VOLUME = "volume";

/**
 * Specials parameters, must be transformed for mScore
 * @type {string}
 */
export const LOGS = "logs";

/**
 * Specials parameters, must be transformed for mScore
 * @type {string}
 */
export const PORT = "port";

/**
 * Constants for all services
 * @type {number}
 */
export const SERVICE_SHOOTER = 1;
export const SERVICE_FLASHTEST = 2;
export const SERVICE_PACKETLOSS = 3;
export const SERVICE_SCORING = 4;

/**
 * gps_lat parameter is used to store GPS latitude
 * @type {string} contains float WGS84
 */
const MSCORE_GPS_LAT = "gps_lat";

/**
 * gps_long parameter is used to store GPS longitude
 * @type {string} contains float WGS84
 */
const MSCORE_GPS_LONG = "gps_lon";

/**
 * gps_radius parameter is used to store GPS precision
 * @type {string} contains int meters
 */
const MSCORE_GPS_RADIUS = "gps_radius";

/**
 * Timestamp of the GPS location (in seconds)
 * @type {string} contains long
 */
const MSCORE_GPS_TIMESTAMP = "gps_tm";

/**
 * Status of the GPS
 * @type {string} contains integer
 */
const MSCORE_GPS_STATUS = "gps_state";

/**
 * gps_city parameter is used to store reverse GPS geocoder information
 * @type {string} zip-code city country
 */
const MSCORE_GPS_CITY = "city";

/**
 * da_gps_address parameter is used to store reverse GPS geocoder information
 * @type {string}
 */
const MSCORE_GPS_ADDRESS = "address";

/**
 * da_gps_zip_code parameter is used to store reverse GPS geocoder information
 * @type {string}
 */
const MSCORE_GPS_ZIP_CODE = "zip_code";

/**
 * da_gps_country_code parameter is used to store reverse GPS geocoder information
 * @type {string}
 */
const MSCORE_GPS_COUNTRY_CODE = "country_code";

/**
 * campaign id for the current scenario

 ▪ @type {string}
 */
const MSCORE_CAMPAIGN_ID = "campaign_id";

/**
 * group id

 ▪ @type {number}
 */
const MSCORE_GROUP_ID = "DA_GROUP_ID";

/**
 * group parameter is used to store/retrieve results (per groupname)

 ▪ @type {string}
 */
const MSCORE_GROUP = "group";

/**
 * multithreading parameter is used to configure the mScore server to accept multiple sockets for a single test session. By default, every new incoming socket will be considered by the mScore server as a new single test. multithreading parameter must be used with tmpid parameter
 * @type {string} yes/no
 */
const MSCORE_MULTISOCKET = "multithreading";

/**
 * sid parameter is used to select session to be downloaded/updated (raw data per session)
 * @type {string}
 */
const MSCORE_SID = "da_sid";

/**
 * tmpid parameter is used to identify multiple threads belonging to the same multithreading test. tmpid parameter must be used with multithreading parameter
 * @type {string} contains long
 */
const MSCORE_SOCKET_ID = "tmpid";

/**
 * uid parameter is used to store/retrieve results (per uid). uid must be unique, minimum length must be 20 chars
 * @type {string}
 */
export const MSCORE_UID = "uid";

/**
 * Allow mScore to push KPI to EQualOne server
 *
 * @type {string} Should be always to yes
 */
const MSCORE_NBI = "nbi";

/**
 * Timestamp of the test (in milliseconds)
 * @type {string}
 */
const MSCORE_DA_TIMESTAMP = "timestamp_agent";
const MSCORE_DA_TIMESTAMP_MS = "created_at_agent_ms";

/**
 * Timezone of the test
 * @type {string}
 */
const MSCORE_DA_TIMEZONE = "timezone_agent";

/**
 * Mode of the test (slm/ssm/ocm)
 * @type {string} always set to 3 (OCM). Web Agent doesn't support SLM & SSM
 */
const MSCORE_DA_MODE_ID = "mode_id";

/**
 * Scenario ID: timestamp in seconds shared by each step in a script
 * @type {string}
 */
const MSCORE_DA_ITERATION_ID = "scenario_id";

/**
 * Version of the agent in String format X.Y.Z.H
 * @type {string}
 */
const MSCORE_DA_DQA_NAME = "dqa_name";
/**
 * Version of the agent in integer format
 * @type {string}
 */
const MSCORE_DA_DQA_VERSION = "dqa_version";
/**
 * Browser name
 * @type {string}
 */
const MSCORE_DA_BROWSER_NAME = "browser_name";
const MSCORE_DA_BROWSER_NAME_CHROME_AGENT = "ChromeAgent";
const MSCORE_DA_OS_NAME = "os_name";

/**
 * Browser version
 * @type {string}
 */
const MSCORE_DA_BROWSER_VERSION = "browser_version";
/**
 * Platform
 * @type {string}
 */
const MSCORE_DA_PLATFORM = "platform";
/**
 * Firmware
 * @type {string}
 */
const MSCORE_DA_FIRMWARE = "firmware";

/**
 * Test to start by mScore
 * @type {string} shooterDL/shooterUL
 */
const MSCORE_TEST = "test";

/**
 * Test to start by mScore
 * @type {string} shooterDL/shooterUL
 */
const MSCORE_URL = "mscore_server";

/**
 * Module for mScore test
 * @type {number} For score
 */
const MSCORE_DA_MODULE = "mscore_module";

/**
 * mScore best server URL check
 * @type {number} For da_cell
 */
export const MSCORE_DA_CELL = "da_cell";

/**
 * mScore private IP
 * @type {string} For da_ip
 */
export const MSCORE_DA_IP = "private_ip";

/**
 * mScore DA fields
 * @type {string} For da fields
 */
export const MSCORE_DA_FIELDS = "da_fields";

/**
 * DA service
 * @type {string} For da service
 */
export const DA_SERVICE = "da_service";

/**
 * DA direction
 * @type {string} For da direction
 */
export const DA_DIRECTION = "da_direction";

/**
 * DA direction proto mapping
 * @type {string} For da direction
 */
export const DA_DIRECTION_MAPPER = "th_type_id";

/**
 * Build mScore URL for test
 */
export default class UrlBuilder {

    /**
     * Default constructor
     *
     * @param {string} uid the unique id of the agent
     * @param {ConfigStepMscore} configuration the server configuration
     * @param {number} campaignId the current campaign id
     * @param {number} iterationId identifier (should be the same for all step in a script)
     * @param {Map<string,string>} customFields A map of custom fields
     * @param {number} group identifier
     * @param {DeviceManager} device manager
     */
    constructor(uid, configuration, campaignId, iterationId, customFields, groupId, deviceManager) {
        this.uid = uid;
        this.port = configuration.getPort();
        this.direction = configuration.getDirection();
        this.service = configuration.getService();
        this.serverParams = MapUtil.objectToMap(configuration.params);
        this.campaignId = campaignId;
        this.iterationId = iterationId;
        this.sid = uid + '-' + Math.round(new Date().getTime());
        this.socketId = this.randomLong();
        this.date = new Date().toISOString();
        this.customFields = customFields;
        this.groupId = groupId;
        this.module = configuration.getModule();
        this.portalUrl = configuration.getPortalUrl();
        this.deviceManager = deviceManager;
    }

    /**
     * Build the mScore test URL
     *
     * @param {String} The mScore server URL
     * @param {GpsInfos} gpsInfos the current agent location
     * @param {Object} gatewayInfos the gateway informations
     * @return {string}
     */
    buildTestUrl(mScoreServerUrl, gpsInfos = null, gatewayInfos = null) {
        return mScoreServerUrl + ':' + this.port + '/' + "operation?" +
            this.buildUrlParams(this.buildMainParams(mScoreServerUrl, this.serverParams, gpsInfos, gatewayInfos));
    }

    /**
     * Build the base test URL
     *
     * @param {String} The mScore server URL
     * @return {string}
     */
    buildBaseUrl(mScoreServerUrl) {
        return mScoreServerUrl + ':' + this.port;
    }

    /**
     * @return {Array} excluded keys from request
     */
    getExcludedKeys() {
        let excludedKeys = [];
        excludedKeys.push(NB_SOCKETS);
        excludedKeys.push(LOGS);
        excludedKeys.push(PORT);
        excludedKeys.push(DA_SERVICE);
        // Remove the volume from parameters if upload test (content-length will be used)
        if (this.direction == ConfigStepEnum.STEP_DIRECTION_UP) {
            excludedKeys.push(VOLUME);
        }
        return excludedKeys;
    }

    /**
     * Build the mScore result URL
     *
     * @param {String} The mScore server URL
     * @param {String} The optional mScore server URL
     * @return {string}
     */
    buildResultUrl(mScoreServerUrl) {
        const param = new Map();
        param.set(MSCORE_UID, this.uid);
        if (this.serverParams.get(NB_SOCKETS) > 1) {
            param.set(MSCORE_MULTISOCKET, "yes");
            param.set(MSCORE_SOCKET_ID, this.socketId);
        }

        return mScoreServerUrl + ':' + this.port + '/' + "update_result?" + this.buildUrlParams(param);
    }

    /**
     * Build input parameters for mScore
     *
     * @param {string} mScoreServerUrl
     * @param {map} configParametersMap
     * @param {GpsInfos} gpsInfos
     * @param {Object} gatewayInfos the gateway informations
     * @return {Map.<string, string>}
     */
    buildMainParams(mScoreServerUrl, configParametersMap, gpsInfos = null, gatewayInfos) {
        const mainParams = new Map();
        const daFields = new Map();

        daFields.set(MSCORE_DA_DQA_NAME, Constants.AGENT_VERSION);
        daFields.set(MSCORE_DA_DQA_VERSION, VersionParser.parseVersion(Constants.AGENT_VERSION));
        mainParams.set(MSCORE_UID, this.uid);
        daFields.set(MSCORE_CAMPAIGN_ID, this.campaignId);
        daFields.set(MSCORE_GROUP_ID, this.groupId);
        mainParams.set(MSCORE_GROUP, this.campaignId);
        if (this.module) {
            daFields.set(MSCORE_DA_MODULE, this.module);
        }
        mainParams.set(MSCORE_TEST, this.getTestServiceLabel(this.direction, this.service));
        const sockets = this.serverParams.get(NB_SOCKETS);

        if (sockets > 1) {
            mainParams.set(MSCORE_MULTISOCKET, "yes");
            mainParams.set(MSCORE_SOCKET_ID, this.socketId);
        } else {
            mainParams.set(MSCORE_MULTISOCKET, "no");
        }
        mainParams.set(MSCORE_SID, this.sid);
        daFields.set(MSCORE_DA_TIMESTAMP, DateUtils.getCurrentTimestamp());
        daFields.set(MSCORE_DA_TIMESTAMP_MS, DateUtils.getCurrentTimestamp() * 1000);
        daFields.set(MSCORE_DA_TIMEZONE, TimeZoneUtils.getJstz().determine().name());
        daFields.set(MSCORE_DA_MODE_ID, 3);
        daFields.set(MSCORE_DA_ITERATION_ID, this.iterationId);

        mainParams.set(MSCORE_DA_CELL, this.deviceManager.getTechnology() + "::");

        const ip = this.deviceManager.getPrivateIpAddress();

        if (ip) {
            daFields.set(MSCORE_DA_IP, ip);
        }

        // Force NBI to yes to spool KPI to EQualOne server
        mainParams.set(MSCORE_NBI, "yes");
        if (gpsInfos) {
            if (gpsInfos.timestamp) daFields.set(MSCORE_GPS_TIMESTAMP, gpsInfos.timestamp);
            if (gpsInfos.status) daFields.set(MSCORE_GPS_STATUS, gpsInfos.status);
            if (gpsInfos.lat) daFields.set(MSCORE_GPS_LAT, gpsInfos.lat);
            if (gpsInfos.long) daFields.set(MSCORE_GPS_LONG, gpsInfos.long);
            if (gpsInfos.radius) daFields.set(MSCORE_GPS_RADIUS, gpsInfos.radius);
            if (gpsInfos.city) daFields.set(MSCORE_GPS_CITY, gpsInfos.city);
            if (gpsInfos.streetName) daFields.set(MSCORE_GPS_ADDRESS, gpsInfos.streetName);
            if (gpsInfos.postalCode) daFields.set(MSCORE_GPS_ZIP_CODE, gpsInfos.postalCode);
            if (gpsInfos.countryCode) daFields.set(MSCORE_GPS_COUNTRY_CODE, gpsInfos.countryCode);
        }

        this.customFields.forEach((value, key) => {
            daFields.set(key, value);
        });

        if (typeof navigator != 'undefined') {
            const uaParserJs = new UAParser();

            const browserName = uaParserJs.getBrowser().name;
            const browserVersion = uaParserJs.getBrowser().version;
            const platform = uaParserJs.getOS().name;


            if (location.protocol === "chrome-extension:") {
                daFields.set(MSCORE_DA_OS_NAME, 10);
                daFields.set(MSCORE_DA_BROWSER_NAME, MSCORE_DA_BROWSER_NAME_CHROME_AGENT);
            } else {
                daFields.set(MSCORE_DA_OS_NAME, 8);
                daFields.set(MSCORE_DA_BROWSER_NAME, browserName);
            }
            daFields.set(MSCORE_DA_BROWSER_VERSION, browserVersion);
            daFields.set(MSCORE_DA_PLATFORM, platform);
            daFields.set(MSCORE_DA_FIRMWARE, navigator.userAgent);
        }

        // Adding configuration parameters, filtered with useless elements
        for (let [configParametersMapKey, configParametersMapValue] of MapUtil.excludeKeys(configParametersMap, this.getExcludedKeys())) {
            // For DA Direction, put in da_fields with real protobuf name
            if (configParametersMapKey.toLowerCase() === DA_DIRECTION.toLowerCase()) {
                daFields.set(DA_DIRECTION_MAPPER, configParametersMapValue);
            } else {
                // For others, => main params
                mainParams.set(configParametersMapKey, configParametersMapValue);
            }
        }

        // EWA-64 Add mscore_url
        daFields.set(MSCORE_URL, mScoreServerUrl + ":" + this.port);

        // EWA-108 Add gateway informations
        if (gatewayInfos) {
            Object.keys(gatewayInfos).forEach((kpiKey) => {
                daFields.set(kpiKey, gatewayInfos[kpiKey]);
            });
        }

        // Added technology on end kpi part (EWA-108)
        // The goal here is to know if customer is connected through Ethernet or Wifi
        // TODO: Put in specific field
        daFields.set("agg_bearer", this.deviceManager.getTechnology());

        // Transform DA_FIELDS
        const daFieldsArray = [];
        daFields.forEach((daFieldValue, daFieldKey) => {
            daFieldsArray.push(daFieldKey + "=" + daFieldValue);
        });

        // Add DA_Fields to main stream
        mainParams.set(MSCORE_DA_FIELDS, daFieldsArray.join(";"));
        return mainParams;
    }

    /**
     * @param {number} da_direction
     * @param {number} da_service
     * @return {string}
     */
    getTestServiceLabel(da_direction, da_service) {
        const direction = da_direction == ConfigStepEnum.STEP_DIRECTION_UP ? "UL" : "DL";
        switch (da_service) {
            case SERVICE_SHOOTER:
                return "shooter" + direction;
            case SERVICE_FLASHTEST:
                return "flashtest" + direction;
            case SERVICE_PACKETLOSS:
                return "packetloss" + direction;
            case SERVICE_SCORING:
                return "score";
        }
        return "unknown" + direction;
    }

    /**
     * Build parameter to format GET call
     * @param {Map.<string, string>} parameters
     * @return {string}
     */
    buildUrlParams(parameters) {
        let tmp = "";
        parameters.forEach(function (value, key) {
            if (tmp) {
                tmp = tmp + "&" + key + "=" + encodeURIComponent(value);
            } else {
                tmp = key + "=" + encodeURIComponent(value);
            }
        });

        return tmp;
    }

    /**
     * Create 64bit random number
     */
    randomLong(currentRandom = 0) {
        if (currentRandom >= 1024) {
            return currentRandom;
        }
        return this.randomLong(parseInt(Math.random() * 10000000));
    }

    buildCheckServerUrl(url) {
        const param = new Map();
        param.set(MSCORE_UID, this.uid);
        param.set(MSCORE_DA_CELL, this.deviceManager.getTechnology());

        return url + ':' + this.port + '/' + "check?" + this.buildUrlParams(param);
    }
}



// WEBPACK FOOTER //
// ./js/core/script/executors/mscore/UrlBuilder.js